import { Component } from '@angular/core';




@Component({
	selector: 'grid-checkbox-editor',
	template: `

    <label *ngIf="showInput" style="margin-bottom:0;" >{{value}}  </label>
    <input  *ngIf="!showInput" type="checkbox" id="isComplete" class="customCheckbox" [(ngModel)]="checked" (change)="onChange($event)">
	<label  *ngIf="!showInput" for="isComplete" class="customCheckboxLabel">{{checked?'COMPLETE':'INCOMPLETE'}}</label>`,
	styles: [`
    input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
  	-webkit-appearance: none;
	  margin: 0;
	}

	.customCheckbox {
		width: 20px;
		height: 20px;
	}
	.customCheckboxLabel {
		margin-left: 6%;
		font-size: 12px;
		vertical-align: super;
	}`
	],
	standalone: false
})

export class GridCheckboxEditorComponent {
	public params: any;
	showInput = true;
	value: any;
	isEmpty = false;
	checked: boolean;
	constructor() { }

	agInit(params: any): void {
		this.params = params;

		this.handleStatusColumn(params, 'diagramCOL', 'diagram');
		this.handleStatusColumn(params, 'lmCOL', 'lm');
		this.handleStatusColumn(params, 'sketchCOL', 'sketch');

		if (this.params.data.checkedEditMode) {
			this.showInput = this.params.column == 'storeAddress' && this.params.data.locationId != null;  // NOSONAR
		} else {
			this.showInput = true;
		}

		if (this.params?.isWriteAccess == false) {  // NOSONAR
			this.showInput = true;
		}
	}

	private handleStatusColumn(
		params: any,
		columnKey: string,
		dataKey: 'diagram' | 'lm' | 'sketch'
	): void {
		if (params.column != columnKey) { // NOSONAR
			return;
		}

		if (params?.isWriteAccess == false) {  // NOSONAR
			this.showInput = true;
		}

		this.value = params.data[dataKey]?.toString().trim();
		this.checked = this.value == 'COMPLETE';  // NOSONAR
		params.data[columnKey] = this;

		if (params.data.rowCheckBox == false) {  // NOSONAR
			this.params.data[dataKey] = this.value;
			this.params.data.isModified = false;
		}
	}




	// called when the cell is refreshed
	refresh(params: any): boolean {
		this.params = params;
		return true;
	}

	public onChange(event) {
		if (this.params.column == 'lmCOL') {  // NOSONAR
			this.params.data.lm = event.currentTarget.checked ? "COMPLETE" : "INCOMPLETE"
		} else if (this.params.column == 'diagramCOL') {  // NOSONAR
			this.params.data.diagram = event.currentTarget.checked ? "COMPLETE" : "INCOMPLETE"
		} else if (this.params.column == 'sketchCOL') {  // NOSONAR
			this.params.data.sketch = event.currentTarget.checked ? "COMPLETE" : "INCOMPLETE"
		}
	}

	onKeyPress(event) {
		if (this.params.column == 'borrow_pickQty' || this.params.column == 'hotcall_pickQty' || this.params.column == 'part_weight' || this.params.column == 'newLocationQty') {  // NOSONAR
			if (event.key == "-" || event.target.value.length == 6 || event.key.toUpperCase() == "E") {  // NOSONAR
				return false;
			} else {
				return true
			}
		} else if (event != null) { // NOSONAR
			return true
		}
		else {
			return false;
		}
	}
}

